<template>
  <span class="channel-badge-status" :class="badgeClasses">
    {{ statusText }}
  </span>
</template>

<script>
// Badge presentacional de estado de canal: el texto y el estado activo (verde)
// los decide el componente padre.
export default {
  props: {
    statusText: {
      type: String,
      required: true,
    },
    active: {
      type: Boolean,
      default: false,
    },
    largeDimensions: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    badgeClasses() {
      return { active: this.active, large: this.largeDimensions };
    },
  },
};
</script>

<style lang="scss" scoped>
.channel-badge-status {
  height: var(--space-two);
  padding: var(--space-micro) var(--space-small);
  font-size: var(--font-size-mini);
  font-weight: var(--font-weight-normal);
  border: 1px solid var(--conversa2-neutral-400-color);
  background-color: var(--white);
  color: var(--conversa2-neutral-600-color);
  line-height: var(--space-normal);
  border-radius: 99px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;

  &.active {
    border: 1px solid var(--conversa2-green-900-color);
    background-color: var(--conversa2-green-50-color);
    color: var(--conversa2-green-800-color);
  }

  &.large {
    height: var(--space-medium);
    width: 14.8rem;
    padding: var(--space-smaller) var(--space-slab);
  }
}
</style>
